import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useCallback, useEffect, useState } from "react";
import debounce from "lodash/debounce";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import useApi from "../../hook/useApi";
import { copyToClipboard, trimAddress } from "../../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import HelpCenterModal from "./HelpCenterModal";

const HelpCenterListLayer = () => {
     const { AsyncGetApiCall, AsyncDeleteApiCall, AsyncPatchAPICall } = useApi();
     const [query, setQuery] = useState({
          pageNo: 1,
          limitVal: 20,
          search: "",
          isAdminReplied: "", // Default to empty string for "All"
     });
     const [loading, setLoading] = useState(false);
     const [data, setData] = useState(null);
     const [show, setShow] = useState(false);
     const [selectedTicket, setSelectedTicket] = useState(null);
     const [action, setAction] = useState("view");
     const navigate = useNavigate();

     const setPageNo = (pageNo) => {
          setQuery((prev) => ({
               ...prev,
               pageNo: pageNo,
          }));
     };

     const getAllHelpCenter = async (showLoader = true) => {
          try {
               if (showLoader) {
                    setLoading(true);
               }
               // Create a query object excluding isAdminReplied if it's an empty string
               const queryParams = {
                    pageNo: query.pageNo,
                    limitVal: query.limitVal,
                    search: query.search,
               };
               if (query.isAdminReplied !== "") {
                    queryParams.isAdminReplied = query.isAdminReplied;
               }

               const result = await AsyncGetApiCall("/help-center/list", queryParams);
               console.log("Result:", result);
               console.log("data", result);

               if (result.success) {
                    setData(result);
               }
          } catch (error) {
               console.log("error...", error);
          } finally {
               if (showLoader) {
                    setLoading(false);
               }
          }
     };

     // Prevent form submission
     const handleFormSubmit = (e) => {
          e.preventDefault(); // Prevent default form submission
     };

     useEffect(() => {
          getAllHelpCenter(false);
     }, [query]);

     const handleDelete = async (id) => {
          if (!id) {
               toast.error("Id not found");
               return;
          }
          try {
               setLoading(true);
               const result = await AsyncDeleteApiCall(`/help-center/delete/${id}`);
               if (result.success) {
                    toast.success("Help Center removed successfully");
                    getAllHelpCenter();
               } else {
                    toast.error(result.message || "Something went wrong");
               }
          } catch (error) {
               console.log("error", error);
          } finally {
               setLoading(false);
          }
     };

     // Admin reply handler
     const handleAdminReply = async (id, name, email, reply) => {
          try {
               console.log("msg", id, name, email, reply);
               setLoading(true);
               const url = `/help-center/admin-reply/${id}`;
               const payload = {
                    name: name,
                    email: email,
                    reply: reply,
               };
               const res = await AsyncPatchAPICall(url, payload);
               if (res.success) {
                    toast.success("Reply sent successfully!");
                    getAllHelpCenter();
               } else {
                    toast.error(res.errors[0] || "Failed to send reply");
               }
          } catch (error) {
               console.log("error", error);
          } finally {
               setLoading(false);
          }
     };

     const handleSearch = (e) => {
          const value = e.target.value;
          // Regex to allow only valid email characters (alphanumeric, dots, hyphens, underscores, @)
          const validEmailChars = /^[a-zA-Z0-9._@-]*$/;
          if (validEmailChars.test(value)) {
               setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
          }
     };

     return (
          <>
               {loading && <Loader />}
               <div className="card h-100 p-0 radius-12">
                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                         <div className="d-flex align-items-center flex-wrap gap-3">
                              <span className="text-md fw-medium text-secondary-light mb-0">
                                   Show
                              </span>
                              <select
                                   className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                   value={query.limitVal}
                                   onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        setQuery((prev) => ({
                                             ...prev,
                                             limitVal: value,
                                             pageNo: 1, // Reset to first page on limit change
                                        }));
                                   }}
                              >
                                   {Array.from({ length: 20 }, (_, i) => {
                                        const value = (i + 1) * 5;
                                        return (
                                             <option key={value} value={value}>
                                                  {value}
                                             </option>
                                        );
                                   })}
                              </select>

                              <span className="text-md fw-medium text-secondary-light mb-0">
                                   Filter By
                              </span>
                              <select
                                   className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                   value={query.isAdminReplied}
                                   onChange={(e) => {
                                        const value = e.target.value;
                                        setQuery((prev) => ({
                                             ...prev,
                                             pageNo: 1,
                                             isAdminReplied: value, // Keep as string ("" for All, "true" or "false")
                                        }));
                                   }}
                                   aria-label="Filter by replied/unreplied"
                              >
                                   <option value="">All</option>
                                   <option value="false">Not Replied</option>
                                   <option value="true">Replied</option>
                              </select>
                              <form className="navbar-search" onSubmit={handleFormSubmit}>
                                   <input
                                        type="text"
                                        className="bg-base h-40-px w-auto"
                                        name="search"
                                        placeholder="Search by email"
                                        value={query.search}
                                        onChange={handleSearch}
                                   />
                                   <Icon icon="ion:search-outline" className="icon" />
                              </form>
                         </div>
                    </div>

                    <div className="card-body p-24">
                         <div className="table-responsive scroll-sm">
                              <table className="table bordered-table sm-table mb-0">
                                   <thead>
                                        <tr>
                                             <th scope="col" className="text-center">
                                                  S.No
                                             </th>
                                             <th scope="col" className="text-center">
                                                  Name
                                             </th>
                                             <th scope="col" className="text-center">
                                                  Email
                                             </th>
                                             <th scope="col" className="text-center">
                                                  Message
                                             </th>
                                             <th scope="col" className="text-center">
                                                  Admin Reply
                                             </th>
                                             <th scope="col" className="text-center">
                                                  Created At
                                             </th>
                                             <th scope="col" className="text-center">
                                                  Action
                                             </th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {data && data.data?.length > 0 ? (
                                             data.data.map((d, index) => (
                                                  <tr key={d._id}>
                                                       <td className="text-center">
                                                            <div className="d-flex justify-content-center align-items-center gap-10">
                                                                 {(data?.pagination?.currentPage - 1) * query.limitVal +
                                                                      index +
                                                                      1}
                                                            </div>
                                                       </td>
                                                       <td className="text-center">{d?.name || "N/A"}</td>
                                                       <td className="text-center">
                                                            {d?.email || "N/A"}
                                                            {d?.email && (
                                                                 <button
                                                                      onClick={() => copyToClipboard(d?.email)}
                                                                      className="ms-3 p-0 border-0 bg-transparent"
                                                                      style={{ lineHeight: 1 }}
                                                                 >
                                                                      <IoCopyOutline />
                                                                 </button>
                                                            )}
                                                       </td>
                                                       <td className="text-center">
                                                            {d?.message?.length > 15
                                                                 ? d?.message?.slice(0, 15) + "..."
                                                                 : d?.message || "N/A"}
                                                       </td>
                                                       <td className="text-center">
                                                            {d?.isAdminReplied ? "Yes" : "No"}
                                                       </td>
                                                       <td className="text-center">
                                                            {new Date(d.createdAt).toLocaleString("en-GB", {
                                                                 day: "2-digit",
                                                                 month: "2-digit",
                                                                 year: "numeric",
                                                                 hour: "2-digit",
                                                                 minute: "2-digit",
                                                                 second: "2-digit",
                                                                 hour12: true,
                                                            })}
                                                       </td>
                                                       <td className="text-center">
                                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                                 <button
                                                                      type="button"
                                                                      className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                      onClick={() => {
                                                                           setShow(true);
                                                                           setSelectedTicket(d);
                                                                           setAction("view");
                                                                      }}
                                                                 >
                                                                      <Icon
                                                                           icon="majesticons:eye-line"
                                                                           className="icon text-xl"
                                                                      />
                                                                      <span className="tooltip-text">View</span>
                                                                 </button>
                                                                 <button
                                                                      type="button"
                                                                      className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                      onClick={() => {
                                                                           setShow(true);
                                                                           setSelectedTicket(d);
                                                                           setAction("reply");
                                                                      }}
                                                                 >
                                                                      <Icon icon="lucide:reply" className="menu-icon" />
                                                                      <span className="tooltip-text">Reply</span>
                                                                 </button>
                                                                 <button
                                                                      onClick={() => {
                                                                           if (
                                                                                window.confirm(
                                                                                     "Are you sure you want to delete this Help Center?"
                                                                                )
                                                                           ) {
                                                                                handleDelete(d?._id);
                                                                           }
                                                                      }}
                                                                      disabled={loading}
                                                                      className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                 >
                                                                      <Icon icon="lucide:trash-2" className="menu-icon" />
                                                                      <span className="tooltip-text">Delete</span>
                                                                 </button>
                                                            </div>
                                                       </td>
                                                  </tr>
                                             ))
                                        ) : (
                                             <tr>
                                                  <td colSpan="8" className="text-center">
                                                       No Help Center found
                                                  </td>
                                             </tr>
                                        )}
                                   </tbody>
                              </table>
                         </div>
                         <Paggination
                              total={data?.pagination?.total || 0}
                              totalPages={data?.pagination?.totalPages || 0}
                              currentPage={data?.pagination?.currentPage || 0}
                              setPageNo={setPageNo}
                              startFrom={(data?.pagination?.currentPage - 1) * query.limitVal + 1}
                              endTo={
                                   (data?.pagination?.currentPage - 1) * query.limitVal +
                                   data?.data?.length
                              }
                         />
                         {show && (
                              <HelpCenterModal
                                   show={show}
                                   handleClose={() => {
                                        setShow(false);
                                        setSelectedTicket(null);
                                   }}
                                   data={selectedTicket}
                                   action={action}
                                   onReply={handleAdminReply}
                              />
                         )}
                    </div>
               </div>
          </>
     );
};

export default HelpCenterListLayer;